module.exports = __webpack_public_path__ + "img/9b37997d8b1377da923ff878c3042557.png";